let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i0VeL")).then(() => parcelRequire('24U8y'));